export default __webpack_public_path__ + "static/media/liveliness-logo.d4c40f03.svg";